import { withStyles, Theme } from '@material-ui/core';
import { default as DefaultConnector } from '@material-ui/core/StepConnector';

const StepConnector = withStyles((theme: Theme) => ({
  root: {
    padding: 2,
  },
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderColor: '#ccc',
    borderTopWidth: theme.spacing(0.75),
    borderRadius: 1,
  },
}))(DefaultConnector);

export default StepConnector;
